(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tlg-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tlg-founder-story')) {
    customElements.define('tlg-founder-story', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.tlg-founder-story__toggle');
        const story = this.querySelector('.rte');
        if (!this.button || !story) return;
        this.more = this.querySelector('[data-founder-more]');
        if (!this.more) {
          const paragraphs = Array.from(story.children).filter(element => element.tagName === 'P');
          const introEnd = paragraphs[1];
          if (!introEnd?.nextElementSibling) return;
          this.more = document.createElement('div');
          this.more.id = this.button.getAttribute('aria-controls');
          this.more.setAttribute('data-founder-more', '');
          while (introEnd.nextSibling) this.more.append(introEnd.nextSibling);
          story.append(this.button, this.more);
        }
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.expanded = this.expanded ?? false;
        this.button.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.updateStory();
        }, options);
        this.mobile.addEventListener('change', () => this.updateStory(), options);
        this.updateStory();
      }

      updateStory() {
        const expanded = !this.mobile.matches || this.expanded;
        this.more.hidden = !expanded;
        this.button.hidden = !this.mobile.matches;
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
      }

      disconnectedCallback() {
        this.events?.abort();
      }
    });
  }
  if (!customElements.get('tlg-editorial-video')) {
    customElements.define('tlg-editorial-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.userStarted = false;
        this.visible = false;
        this.video.muted = true;
        this.video.controls = false;
        this.button.hidden = false;
        this.video.addEventListener('play', () => this.updateButton(), options);
        this.video.addEventListener('pause', () => this.updateButton(), options);
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.userStarted = true;
            this.playVideo();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.motion.addEventListener('change', () => {
          this.userStarted = false;
          this.updatePlayback();
        }, options);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.updatePlayback();
        });
        this.observer.observe(this);
        this.updateButton();
      }

      playVideo() {
        this.video.play().catch(() => this.updateButton());
      }

      updatePlayback() {
        if (this.visible && !document.hidden && !this.userPaused && (!this.motion.matches || this.userStarted)) {
          this.playVideo();
        } else {
          this.video.pause();
        }
      }

      updateButton() {
        const playing = !this.video.paused;
        this.toggleAttribute('data-playing', playing);
        this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlg-make-it-yours"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tlg-craft-film')) {
    customElements.define('tlg-craft-film', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button || this.abort) return;

        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.visible = false;
        this.video.controls = false;
        this.video.muted = true;
        this.button.hidden = false;

        const sync = () => {
          this.toggleAttribute('data-playing', !this.video.paused);
          this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        };
        this.play = () => { this.video.play().catch(sync); };
        this.autoPlay = () => {
          if (this.visible && !document.hidden && this.dataset.autoplay === 'true' && !this.motion.matches && !this.userPaused) this.play();
        };

        this.video.addEventListener('play', sync, options);
        this.video.addEventListener('pause', sync, options);
        this.video.addEventListener('error', () => {
          this.button.hidden = true;
          this.video.controls = true;
        }, options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.video.paused) this.play();
          else this.video.pause();
        }, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.video.pause();
          else this.autoPlay();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause();
          else this.autoPlay();
        }, options);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            this.visible = entry.isIntersecting && entry.intersectionRatio >= .25;
            if (this.visible) this.autoPlay();
            else this.video.pause();
          }, { threshold: [0, .25] });
          this.observer.observe(this);
        }
        sync();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
